/* @ngInject */
function artSizesService (CONSTANTS, Utils, ConnectorWebService) {
  const service = {
    getArtSizes,
    getArtSizeById,
    setArtSizeFavorite,
    renameArtSize,
    deleteArtSize,
    createArtSize,
    setArtSizeAsRecent
  }

  return service

  function getArtSizes (params) {
    const { top, skip, filter, search, width, height, measureUnit } = params

    let url = CONSTANTS.URL_ART_SIZES

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    if (filter) {
      url = Utils.fnAddQueryToUrl(url, { filter })
    }

    if (search) {
      url = Utils.fnAddQueryToUrl(url, { search })
    }

    if (width) {
      url = Utils.fnAddQueryToUrl(url, { width })
    }

    if (height) {
      url = Utils.fnAddQueryToUrl(url, { height })
    }

    if (measureUnit) {
      url = Utils.fnAddQueryToUrl(url, { measureUnit })
    }

    return ConnectorWebService.get(url)
  }

  function getArtSizeById (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_SIZES_ID, [id])

    return ConnectorWebService.get(url)
  }

  function setArtSizeFavorite (id, isFavorite) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_SIZES_ID_FAVORITE, [id])

    return ConnectorWebService.put(url, { isFavorite })
  }

  function renameArtSize (id, name) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_SIZES_ID_RENAME, [id])

    return ConnectorWebService.put(url, { name })
  }

  function deleteArtSize (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_SIZES_ID, [id])

    return ConnectorWebService.fnDelete(url)
  }

  function createArtSize (artSize) {
    const url = CONSTANTS.URL_ART_SIZES
    return ConnectorWebService.post(url, artSize)
  }

  function setArtSizeAsRecent (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_SIZES_ID_SELECT, [id])
    return ConnectorWebService.post(url)
  }
}

export { artSizesService }
